/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Mixins
import settings from './settings';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import CollapsibleSelect from 'shared/ui/components/form-components/CollapsibleSelect.vue';
import InputWithUnit from 'shared/ui/components/form-components/InputWithUnit.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'SupportOptions',

    components: { BaseInput, CollapsibleSelect, InputWithUnit, Toggler },

    mixins: [settings],

    data() {
        return {
            mdFieldsLimitChanged: false,
            showCongressExcellenceSection: false,
            supportTicketNumber: null,
            liveStreams: {
                max_duration_hours: 0,
                max_preview_hours: 0,
                max_rtmps_duration_hours: 0,
                max_rtmps_preview_hours: 0
            },
            innerValue: {
                enable_google_calendar: false,
                entitlements_enabled: false,
                entitlements_v2: false,
                app_activation_from_direct_login: false,
                hide_cancelled: false,
                metadata_fields_limit: 75,
                live_streams: {
                    max_duration_hours: 0,
                    max_preview_hours: 0,
                    max_rtmps_duration_hours: 0,
                    max_rtmps_preview_hours: 0
                },
                webapp: {
                    one_time_token: false,
                    session_ttl: 0
                }
            }
        };
    },

    computed: {
        /** @returns {boolean} */
        showLiveStreamSettings() {
            return this.$services.user.hasPermission('org_realms.change_live_stream_settings', { org_id: this.event.ownerId });
        },

        creation() {
            const date = this.$utils.time.tsToLongDateTimeFormat(this.event.created);
            const user = this.$utils.strings.emailFromUserId(this.event.created_by);
            return `${date} ${this.$t('base.by')} ${user}`;
        },

        ipsList() {
            return get(this.innerValue.webapp, 'source_network_whitelist', []);
        },

        supportTicketValidations() {
            return this.mdFieldsLimitChanged ? 'required_if:fieldsLimit' : null;
        }
    },

    watch: {
        liveStreams: {
            deep: true,
            immediate: true,
            handler() {
                this.innerValue.live_streams = {
                    max_stream_duration: this.liveStreams.max_duration_hours * 3600,
                    max_preview_duration: this.liveStreams.max_preview_hours * 3600,
                    max_rtmps_stream_duration: this.liveStreams.max_rtmps_duration_hours * 3600,
                    max_rtmps_preview_duration: this.liveStreams.max_rtmps_preview_hours * 3600
                };
            }
        }
    },

    methods: {
        init() {
            this.mdFieldsLimitChanged = false;

            this.showCongressExcellenceSection = this.event.enable_google_calendar !== undefined;

            this.innerValue.enable_google_calendar = this.event.enable_google_calendar;
            this.innerValue.entitlements_enabled = this.event.entitlements_enabled;
            this.innerValue.entitlements_v2 = this.event.entitlements_v2;
            this.innerValue.app_activation_from_direct_login = this.event.app_activation_from_direct_login;
            this.innerValue.hide_cancelled = this.event.hide_cancelled;
            this.innerValue.metadata_fields_limit = this.event.metadata_fields_limit || 50;

            this.innerValue.webapp = this.event.webapp || {};

            const toHours = field => Math.floor(get(this.event, `live_streams.${field}`, 0)) / 3600;

            this.liveStreams.max_duration_hours = toHours('max_stream_duration');
            this.liveStreams.max_preview_hours = toHours('max_preview_duration');
            this.liveStreams.max_rtmps_duration_hours = toHours('max_rtmps_stream_duration');
            this.liveStreams.max_rtmps_preview_hours = toHours('max_rtmps_preview_duration');
        },

        preSubmitHook() {
            if (this.supportTicketNumber) {
                this.$emit('reason', this.supportTicketNumber);
            }
        },

        promptArchiving() {
            if (!this.userIsAdminOrSupport) {
                this.$notify({
                    group: 'flashes',
                    text: this.$t('general_settings.messages.no_archive_permission').toString(),
                    type: 'error',
                    duration: 15000
                });
                return;
            }

            const text = this.$t(
                this.$utils.workspaces.isEventLive(this.event)
                    ? 'general_settings.messages.archive_confirmation_when_live'
                    : 'general_settings.messages.archive_confirmation'
            );
            this.$modal.show('dialog', {
                title: this.$t('general_settings.messages.archive_confirmation_title'),
                text,
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general_settings.actions.archive'),
                        handler: () => this.archive(),
                        class: 'btn btn-warn'
                    }
                ]
            });

        },

        async archive() {
            try {
                const node = this.$utils.workspaces.getRootNodeName(this.event);
                const data = await this.$services.event.archiveEvent(this.event._id, node);

                console.debug('[SupportOptions] Archive successful', data);

                this.$notify({
                    group: 'flashes',
                    text: this.$t('general_settings.messages.archiving_in_progress').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$services.router.redirectToHome();

            } catch (error) {
                console.error('[SupportOptions] An error occurred while archiving', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$t('general_settings.messages.archiving_request_failed').toString(),
                    type: 'error',
                    duration: 5000
                });

                this.$services.crashReporting.captureException(error);
            }
        },

        convertToTemplate() {
            this.$modal.show('dialog', {
                text: this.$t('general_settings.messages.template_conversion_confirmation'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general_settings.actions.convert_to_template'),
                        handler: async () => {
                            await this.$services.event.convertToTemplate(this.event);
                            window.location.reload();
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * @param {string} data
         */
        addIp(ip) {
            this.innerValue.webapp = {
                ...this.innerValue.webapp,
                source_network_whitelist: this.ipsList.concat([ip])
            };
        },

        /**
         * @param {string} data
         */
        removeIp(ip) {
            this.innerValue.webapp = {
                ...this.innerValue.webapp,
                source_network_whitelist: this.ipsList.filter(i => i !== ip)
            };
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"support-options",attrs:{"tag":"form","autocomplete":"off"}},[_c('div',{staticClass:"alert alert-info"},[_c('h3',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.event_config')))]),_c('dl',{staticClass:"small"},[_c('dt',[_vm._v(_vm._s(_vm.$t('general_settings.info.creation'))+":")]),_c('dd',[_vm._v(_vm._s(_vm.creation))]),_c('dt',[_vm._v(_vm._s(_vm.$t('general_settings.info.allow_non_unique_email'))+":")]),_c('dd',[_vm._v(_vm._s(_vm.event.allow_non_unique_email ? _vm.$t('base.yes') : _vm.$t('base.no')))]),_c('dt',[_vm._v(_vm._s(_vm.$t('general_settings.info.mail_provider'))+":")]),_c('dd',[_vm._v(_vm._s(_vm.event.mail_provider || _vm.$t('base.not_available')))]),_c('dt',[_vm._v(_vm._s(_vm.$t('general_settings.info.white_label_domain'))+":")]),_c('dd',[_vm._v(_vm._s(_vm.event.white_label_domain || _vm.$t('base.none')))]),_c('dt',[_vm._v(_vm._s(_vm.$t('general_settings.info.is_anonymized'))+":")]),_c('dd',[_vm._v(_vm._s(_vm.event.is_anonymized ? _vm.$t('base.yes') : _vm.$t('base.no')))])])]),_c('div',{staticClass:"alert alert-warning",attrs:{"ng-if":"showLiveStreamSettings"}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.live_streams')))]),_c('div',{staticClass:"panels panels-a"},[_c('div',{staticClass:"panel"},[_c('h5',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.studio')))]),_c('validation-provider',{attrs:{"rules":"required|min_value:0.25|max_value:10","slim":true,"name":"max_preview_hours"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-unit',{attrs:{"type":"number","name":"max_preview_hours","min":0.25,"max":10,"label":_vm.$t('general_settings.form.max_preview_hours'),"errors":errors},model:{value:(_vm.liveStreams.max_preview_hours),callback:function ($$v) {_vm.$set(_vm.liveStreams, "max_preview_hours", $$v)},expression:"liveStreams.max_preview_hours"}},[_c('span',[_vm._v(_vm._s(_vm.$t('general_settings.form.hours')))])])]}}])}),_c('validation-provider',{attrs:{"rules":"required|min_value:0.25|max_value:10","slim":true,"name":"max_duration_hours"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-unit',{attrs:{"type":"number","name":"max_duration_hours","min":0.25,"max":10,"label":_vm.$t('general_settings.form.max_duration_hours'),"errors":errors},model:{value:(_vm.liveStreams.max_duration_hours),callback:function ($$v) {_vm.$set(_vm.liveStreams, "max_duration_hours", $$v)},expression:"liveStreams.max_duration_hours"}},[_c('span',[_vm._v(_vm._s(_vm.$t('general_settings.form.hours')))])])]}}])})],1),_c('div',{staticClass:"panel"},[_c('h5',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.rtmps')))]),_c('validation-provider',{attrs:{"rules":"required|min_value:0.25|max_value:10","slim":true,"name":"max_rtmps_preview_hours"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-unit',{attrs:{"type":"number","name":"max_rtmps_preview_hours","min":0.25,"max":10,"label":_vm.$t('general_settings.form.max_rtmps_preview_hours'),"errors":errors},model:{value:(_vm.liveStreams.max_rtmps_preview_hours),callback:function ($$v) {_vm.$set(_vm.liveStreams, "max_rtmps_preview_hours", $$v)},expression:"liveStreams.max_rtmps_preview_hours"}},[_c('span',[_vm._v(_vm._s(_vm.$t('general_settings.form.hours')))])])]}}])}),_c('validation-provider',{attrs:{"rules":"required|min_value:0.25|max_value:24","slim":true,"name":"max_rtmps_duration_hours"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-unit',{attrs:{"type":"number","name":"max_rtmps_duration_hours","min":0.25,"max":24,"label":_vm.$t('general_settings.form.max_rtmps_duration_hours'),"errors":errors},model:{value:(_vm.liveStreams.max_rtmps_duration_hours),callback:function ($$v) {_vm.$set(_vm.liveStreams, "max_rtmps_duration_hours", $$v)},expression:"liveStreams.max_rtmps_duration_hours"}},[_c('span',[_vm._v(_vm._s(_vm.$t('general_settings.form.hours')))])])]}}])})],1)])])]),(_vm.showCongressExcellenceSection)?_c('div',{staticClass:"alert alert-warning"},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.congress_excellence')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"enable_google_calendar","off-label":_vm.$t('general_settings.form.enable_google_calendar'),"on-label":_vm.$t('general_settings.form.enable_google_calendar')},model:{value:(_vm.innerValue.enable_google_calendar),callback:function ($$v) {_vm.$set(_vm.innerValue, "enable_google_calendar", $$v)},expression:"innerValue.enable_google_calendar"}})],1)],1)]):_vm._e(),_c('div',{staticClass:"alert alert-warning"},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.support')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"hide_cancelled_enabled","off-label":_vm.$t('general_settings.form.hide_cancelled'),"on-label":_vm.$t('general_settings.form.hide_cancelled')},model:{value:(_vm.innerValue.hide_cancelled),callback:function ($$v) {_vm.$set(_vm.innerValue, "hide_cancelled", $$v)},expression:"innerValue.hide_cancelled"}})],1),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-warn",attrs:{"type":"button"},on:{"click":function($event){return _vm.promptArchiving()}}},[_vm._v(_vm._s(_vm.$t('general_settings.actions.archive')))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('general_settings.messages.archive')))])]),_c('h5',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.webapp')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"one_time_links","tip":_vm.$t('general_settings.messages.one_time_links_tip'),"off-label":_vm.$t('general_settings.form.one_time_links'),"on-label":_vm.$t('general_settings.form.one_time_links')},model:{value:(_vm.innerValue.webapp.one_time_token),callback:function ($$v) {_vm.$set(_vm.innerValue.webapp, "one_time_token", $$v)},expression:"innerValue.webapp.one_time_token"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.session_ttl'),"hint":_vm.$t('general_settings.messages.session_ttl_hint'),"hint-after-label":true,"name":"session_ttl","type":"number"},model:{value:(_vm.innerValue.webapp.session_ttl),callback:function ($$v) {_vm.$set(_vm.innerValue.webapp, "session_ttl", $$v)},expression:"innerValue.webapp.session_ttl"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('collapsible-select',{attrs:{"label":_vm.$t('general_settings.form.whitelisted_ips'),"placeholder":_vm.$t('general_settings.messages.whitelisted_ips'),"hint":_vm.$t('general_settings.messages.whitelisted_ips_hint'),"hint-after-label":true,"name":"whitelisted_ips","value":_vm.ipsList,"options":_vm.ipsList,"optionsLabel":null,"multiple":"multiple","taggable":"taggable"},on:{"tag":_vm.addIp,"remove":_vm.removeIp}})],1)],1)]),(_vm.userIsSuperAdmin)?_c('div',{staticClass:"alert alert-danger"},[_c('fieldset',{staticClass:"admin-options"},[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.admin')))]),_c('toggler',{attrs:{"name":"app_direct_login_enabled","label":_vm.$t('general_settings.form.app_direct_login'),"off-label":_vm.$t('general.disabled'),"on-label":_vm.$t('general.enabled')},model:{value:(_vm.innerValue.app_activation_from_direct_login),callback:function ($$v) {_vm.$set(_vm.innerValue, "app_activation_from_direct_login", $$v)},expression:"innerValue.app_activation_from_direct_login"}}),_c('toggler',{attrs:{"name":"entitlements_enabled","label":_vm.$t('general_settings.form.entitlements'),"off-label":_vm.$t('general.disabled'),"on-label":_vm.$t('general.enabled')},model:{value:(_vm.innerValue.entitlements_enabled),callback:function ($$v) {_vm.$set(_vm.innerValue, "entitlements_enabled", $$v)},expression:"innerValue.entitlements_enabled"}}),_c('toggler',{attrs:{"name":"entitlements_v2","label":_vm.$t('general_settings.form.entitlements_v2'),"off-label":_vm.$t('general.disabled'),"on-label":_vm.$t('general.enabled')},model:{value:(_vm.innerValue.entitlements_v2),callback:function ($$v) {_vm.$set(_vm.innerValue, "entitlements_v2", $$v)},expression:"innerValue.entitlements_v2"}}),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.convertToTemplate()}}},[_vm._v(_vm._s(_vm.$t('general_settings.actions.convert_to_template')))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('general_settings.messages.convert_to_template')))])]),_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"slim":true,"name":"metadata_fields_limit","vid":"fieldsLimit"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"name":"metadata_fields_limit","type":"number","label":_vm.$t('general_settings.form.metadata_fields_limit'),"hint":_vm.$t('general_settings.messages.metadata_fields_limit_hint'),"errors":errors},on:{"input":function($event){_vm.mdFieldsLimitChanged = true}},model:{value:(_vm.innerValue.metadata_fields_limit),callback:function ($$v) {_vm.$set(_vm.innerValue, "metadata_fields_limit", $$v)},expression:"innerValue.metadata_fields_limit"}})]}}],null,false,1721289756)}),_c('validation-provider',{attrs:{"slim":true,"rules":_vm.supportTicketValidations,"name":_vm.$t('general_settings.form.metadata_fields_limit_increase_ticket')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"name":"support_ticket_for_fields_limit_increase","label":_vm.$t('general_settings.form.metadata_fields_limit_increase_ticket'),"hint":_vm.$t('general_settings.messages.metadata_fields_limit_increase_ticket_hint'),"errors":errors},model:{value:(_vm.supportTicketNumber),callback:function ($$v) {_vm.supportTicketNumber=$$v},expression:"supportTicketNumber"}})]}}],null,false,3788073325)})],1)],1)]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SupportOptions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__